import moment from "moment";

// Example Execution metadata:
// iopub.execute_input: "2021-05-18T19:10:38.015083Z"
// iopub.status.busy: "2021-05-18T19:10:38.014436Z"
// iopub.status.idle: "2021-05-18T19:10:38.027903Z"
// shell.execute_reply: "2021-05-18T19:10:38.026354Z"
// shell.execute_reply.started: "2021-05-18T19:10:38.014991Z"

export interface CellExecution {
  "iopub.execute_input": string | null;
  "shell.execute_reply": string | null;
}

const RUNNING_CELL_PROMPT_TEXT = "[*]:";

export const executionTooltip = (
  execution?: CellExecution,
  promptText?: string
) => {
  const isRunningOrQueuedMsg =
    promptText === RUNNING_CELL_PROMPT_TEXT
      ? "Cell execution is queued"
      : "Cell hasn't been executed yet";
  if (!execution) {
    return isRunningOrQueuedMsg;
  }
  const input = execution["iopub.execute_input"];
  if (!input) {
    return isRunningOrQueuedMsg;
  }
  const startTime = moment(input).format("h:mma");

  const reply = execution["shell.execute_reply"];
  if (!reply) {
    return `Cell execution started at ${startTime}`;
  }

  const execRuntime = moment.duration(moment(reply).diff(input)).asSeconds();
  return `Cell executed in ${execRuntime}s at ${startTime}`;
};
